module.exports = __webpack_public_path__ + "img/free_multiplier_10.0567d787.png";